<div [class]="skinName">

  <div class="icons-container" [ngClass]="[(!haslottie) ? 'h-200' : '', hasHeaderTitle ? 'no-margin' : 'margin-set']">
    <img [src]="icon" alt="" class="icon">
    @if (haslottie) {
      <div class="lottie-container">
        <ng-lottie width="60px" height="60px" [options]="lottieOptions"></ng-lottie>
      </div>
    }
  </div>
  <p class="top-text mt-0">{{ toptext }}</p>

  <p>{{ bottomtext }}</p>
  @if (redeemWatchBtn) {
    <div class="redeem-btn-block">
      <button (click)="pageNavigate()" class="btn watch-redeem">
        <div class="d-flex align">
          <span>{{configService.localeKeys?.['common_keys.watch_now.text']}}</span>
          <img id="right-arrow" src="branding/theme/assets/static_assets/ic-left-arrow-on-lbg.svg">
        </div>
      </button>
    </div>
  }
  @if (buttontext) {
    <button class="uk-button submit-btn">{{ buttontext }}</button>
  }
  @if (closeButtonText) {
    <button type="button" class="uk-button submit-btn uk-modal-close">{{ closeButtonText }}</button>
  }

</div>